interface PageLoaderProps {
  label?: string;
  fixed?: boolean;
}

export function PageLoader({ label = "Carregando conteúdo", fixed = true }: PageLoaderProps) {
  return (
    <div
      className={[
        "flex items-center justify-center overflow-hidden bg-background px-6",
        fixed ? "fixed inset-0 z-50 h-[100lvh] min-h-[100svh]" : "min-h-[100svh]",
      ].join(" ")}
    >
      <div className="flex flex-col items-center gap-4" role="status" aria-live="polite" aria-label={label}>
        <span className="sr-only">{label}</span>
        <div className="page-loader__spinner" aria-hidden="true" />
      </div>
    </div>
  );
}
